export default "__VITE_ASSET__Bv04Fn8a__"